// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"hamburger-module--hamburger--4poKS","box":"hamburger-module--box--P_z12","inner":"hamburger-module--inner--1pEt-","isActive":"hamburger-module--is-active--2mKv6"};